const PREVIEW_MEDIA_ID_PREFIX = 'preview-';

/** Template previews can't persist media, so they mint local ids that must never be submitted or drafted. */
export const createPreviewMediaId = (uuid: string) => `${PREVIEW_MEDIA_ID_PREFIX}${uuid}`;

export const isPersistedMediaId = (id: unknown): id is string =>
  typeof id === 'string' && !!id && !id.startsWith(PREVIEW_MEDIA_ID_PREFIX);
